module.exports = __webpack_public_path__ + "static/media/hh_logo_light.cc81cceb.svg";